module.exports = __webpack_public_path__ + "img/face-dizzy.6dfc83b3.svg";